export const subCategoryDropdown = () => [
  { id: 'Technical Issue', description: 'Technical Issue', filterField: 'A' },
  { id: 'Product Assistance', description: 'Product Assistance', filterField: 'A' },
  { id: 'Account Access', description: 'Account Access', filterField: 'A' },
  { id: 'General Inquiries', description: 'General Inquiries', filterField: 'B' },
  { id: 'Quote Status', description: 'Quote Status', filterField: 'B' },
  { id: 'Returns & Refunds', description: 'Returns & Refunds', filterField: 'B' },
  { id: 'Customer Feedback', description: 'Customer Feedback', filterField: 'B' },
  { id: 'Customer Onboarding', description: 'Customer Onboarding', filterField: 'C' },
  { id: 'Account Management', description: 'Account Management', filterField: 'C' },
  { id: 'Service Customization', description: 'Service Customization', filterField: 'C' },
  { id: 'Renewal and Upgrades', description: 'Renewal and Upgrades', filterField: 'C' },
  { id: 'Training & Resources', description: 'Training & Resources', filterField: 'C' },
  { id: 'Proactive Outreach', description: 'Proactive Outreach', filterField: 'C' },
  { id: 'Lead Tracking', description: 'Lead Tracking', filterField: 'D' },
  { id: 'Sales Follow-up', description: 'Sales Follow-up', filterField: 'D' },
  { id: 'Contract Details', description: 'Contract Details', filterField: 'D' },
  { id: 'Enrollment', description: 'Enrollment', filterField: 'D' },
  { id: 'Service Quality', description: 'Service Quality', filterField: 'E' },
  { id: 'Product Problems', description: 'Product Problems', filterField: 'E' },
  { id: 'Billing Discrepancies', description: 'Billing Discrepancies', filterField: 'E' },
  { id: 'Customer Experience', description: 'Customer Experience', filterField: 'E' },
];
